/** Both historical new-request URLs open the same existing creation flow. */
import { StartRequestPage } from "./StartRequestPage";
export function RequestsNewPage() {
  return <StartRequestPage />;
}
